class SimpleArchiveControler {

  //
  //  ArchiveControler Documentatie
  //  Depandancy: jQuery - voor $.get functie

  //  1. Registeer more-button en section_container
  //  2. (optioneel) Gebruik callbacks (ondersteund standaard functie per event)
  //

  constructor() {
    this.version = 1.1;               // versiebeheer van script
    this.self_loading = false;        // zelf bezig

    this.more_button_classname = '';  // button wordt overschreven per call
    this.self_loading_classname = 'more-loading'; // eigen loadingclass voor de body

    this.archive_container = null;    // ajax vevangt innerHTML
    this.archive_observer = null;     // monitor innerHTML

    this.callbacks = {
      'load' : null,
      'endload' : null,
      'change' : null,
      'ajax' : null,
      'new-content' : null
    };
  }

  // Config

  register_archive_container( _el ) {
    if( _el == null ) return;
    this.archive_observer = new MutationObserver( this.archive_changed.bind(this) );
    this.archive_observer.observe( _el, { 
      childList: true,
      subtree: true // indien noodzakelijk true, default false 
    });
    this.archive_container = _el;
  }

  register_more_button_classname( _classname ) {
    this.more_button_classname = _classname;
    this.set_more_button();
  }

  register_self_loading_classname( _classname ) {
    this.self_loading_classname = _classname;
  }

  on( _eventname, _callback_function ) {
    if( !(typeof _callback_function == 'function') ) { console.log('callback mist functie'); return; }
    if( !this.callbacks.hasOwnProperty(_eventname )){ console.log('onbekend event voor callback'); return; }
    this.callbacks[_eventname] = _callback_function;
  }

  set_more_button() {
    if( !this.more_button_classname ) return;
    const more_btn = this.archive_container.querySelector('.' + this.more_button_classname);
    if( more_btn ) more_btn.addEventListener( 'click', this.update_more.bind(this) );
  }

  // Loading

  start_loading() {
    this.self_loading = true;

    if( this.self_loading_classname && !document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.add(this.self_loading_classname);

    if( typeof this.callbacks['load'] === 'function' )
      this.callbacks['load'](this);
  }

  stop_loading() {
    this.self_loading = false;

    if( this.self_loading_classname && document.body.classList.contains(this.self_loading_classname) )
      document.body.classList.remove(this.self_loading_classname);

    if( typeof this.callbacks['endload'] === 'function' )
      this.callbacks['endload'](this);
  }

  // Input Events

  archive_changed() {
    this.set_more_button();
    if( typeof this.callbacks['change'] === 'function' )
      this.callbacks['change'](this);
    // Plaats voor animatie
    // Bijvoorbeeld door een class "new" weg te halen o.i.d.
  }

  update_more( e ) {
    e.preventDefault();
    if( !e.target.hasAttribute('href') ) { console.log('more-button mist href'); return; }
    this.update_archive(e.target.getAttribute('href'));
  }

  // Ajax

  update_archive(ajax_url) {
    if( this.self_loading ) { console.log('still loading ...'); return; }
    if( this.ajax_url == false ) { console.log('no ajax url'); return; }
    if( this.archive_container == null ) { console.log('empty archive container'); return; }

    const self = this;
    self.start_loading();

    // querystring

    var data = {};

    // ajax-call

    try {
      jQuery.get(ajax_url, function (data) {
        try {
          // Custom Ajax afhandeling 1 (replace)
          if( typeof self.callbacks['ajax'] === 'function' ) {
            self.callbacks['ajax'](data, page, self);
            return;
          }

          // Default Ajax afhandeling
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");
          const newContent = htmlDoc.getElementById( self.archive_container.id );

          const more_btn = self.archive_container.querySelector('.' + self.more_button_classname);
          if( more_btn ) more_btn.remove();
          self.archive_container.innerHTML += newContent.innerHTML;

          if( typeof self.callbacks['new-content'] === 'function' ) {
            self.callbacks['new-content'](htmlDoc, newContent);
          }

          // handle more button via mutationobserver
        } catch (e) {
          console.log(e);
        }
      })
        .fail(function (jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        })
        .always(function () {
          self.stop_loading();
        });
    } catch (e) {
      self.stop_loading();
    }

  }

}